import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1225.257 -4200.39)">
      <path
        d="M415.493,38.14a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4163)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M428.473,45.646a15.048,15.048,0,0,0-5.486-5.486,14.9,14.9,0,0,0-7.494-2.02v15L408,40.16a15,15,0,0,0,7.5,27.98,14.981,14.981,0,0,0,12.98-22.494"
        transform="translate(-1625 4163)"
        fill={color}
      />
    </g>
  </svg>
);
